import { render, staticRenderFns } from "./v-month-picker.vue?vue&type=template&id=2735a947&scoped=true&"
import script from "./v-month-picker.vue?vue&type=script&lang=js&"
export * from "./v-month-picker.vue?vue&type=script&lang=js&"
import style0 from "./v-month-picker.vue?vue&type=style&index=0&id=2735a947&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735a947",
  null
  
)

export default component.exports